<template>
    <div>
        <DefaultMenu>
            <template #title>
                Reuniones
            </template>
     
            <b-button v-b-modal.createModal
                v-permission="'reuniones-menu-crear'"
            >
                Crear <b-icon icon="calendar2-plus" font-scale="1"></b-icon>
            </b-button>

            <template #right>
                <b-button
                    v-permission="'reuniones-reportes'"
                    class="mx-2"
                    v-b-modal.reportModal
                    title="Generar Reporte"
                    v-b-tooltip.hover.left
                >
                    <b-icon icon="file-pdf"/>
                </b-button>
            </template>
        </DefaultMenu>

        <!-- Modal Crear -->
        <b-modal
          id="createModal"
          size="lg"
          hide-footer
          centered
          header-bg-variant="dark"
        >
            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>
            </template>

            <MeetingForm/>
        </b-modal>

        <!-- Modal Reporte -->
        <b-modal 
            id="reportModal" 
            title="Generar reporte" 
            size="xl" 
            centered 
            scrollable 
            header-bg-variant="dark"
            v-model="modalShowReport" 
            hide-footer
        >
            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>
            </template>

            <MeetingReport></MeetingReport>
        </b-modal>
    </div>
</template>

<script>
import DefaultMenu from '@/components/shared/Default-menu.vue'
import MeetingForm from '@/components/Meeting/MeetingCreate/Meeting-form.vue'
import MeetingReport from '@/components/Meeting/Meeting-report.vue'

export default {
    name: 'MeetingCreate',

    components: {
      DefaultMenu,
      MeetingForm,
      MeetingReport
    },

    data() {
        return {
            modalShow: false,
            modalShowReport: false
        }
    },

    methods: {
        openModal() {
            this.modalShow = true;
        },

        closeModal() {
            this.modalShow = false;
        },
    }
}
</script>
